export const LANGUAGE_STORAGE_KEY = "app-language";

export const translations = {
  en: {
    Dashboard: "Dashboard",
    Dashboards: "Dashboards",
    Monitorings: "Monitorings",
    Reports: "Reports",
    History: "History",
    Records: "Records",
    "Alarm Manager": "Alarm Manager",
    "Alert Manager": "Alarm Manager",
    Manual: "Manual",
    Settings: "Settings",
    Connections: "Connections",
    "Tag Groups": "Tag Groups",
    Accounts: "Accounts",
    System: "System",
    Alarms: "Alarms",
    Alerts: "Alarms",
    alarms: "alarms",
    alerts: "alarms",
    dashboard: "dashboard",
    history: "history",
    records: "records",
    manual: "manual",
    connections: "connections",
    "tag groups": "tag groups",
    accounts: "accounts",
    system: "system",
    "alarm reports": "alarm reports",
    "alert reports": "alarm reports",
    "Alert Reports": "Alarm Reports",
    Alert: "Alarm",
    "Alert:": "Alarm:",
    State: "State",
    "State:": "State:",
    Started: "Started",
    Ended: "Ended",
    Viewed: "Viewed",
    Duration: "Duration",
    Total: "Total",
    Active: "Active",
    Summary: "Summary",
    "Active Alerts": "Active Alarms",
    "All Active Alerts": "All Active Alarms",
    "Alert History": "Alarm History",
    "Alert Summary": "Alarm Summary",
    "Filter by alert": "Filter by alarm",
    "Click one alert row to filter its history": "Click one alarm row to filter its history",
    "Alert Detail": "Alarm Detail",
    "Start value:": "Start value:",
    "End value:": "End value:",
    "Start data:": "Start data:",
    "End data:": "End data:",
    "Historical Alert Type": "Historical Alarm Type",
    "Historical Alert Tag": "Historical Alarm Tag",
    "Historical Configuration": "Historical Configuration",
    "Marked as viewed": "Marked as viewed",
    Note: "Note",
    "Unable to load alert detail": "Unable to load alarm detail",
    "Alert record updated": "Alarm record updated",
    "Alert records cleared": "Alarm records cleared",
    "Unable to update alert record": "Unable to update alarm record",
    "Unable to clear alert records": "Unable to clear alarm records",
    "load failed": "load failed",
    "update failed": "update failed",
    "update succeeded": "update succeeded",
    "Alert Types": "Alarm Types",
    "Alert Tags": "Alarm Tags",
    "Alert Type": "Alarm Type",
    "Alert Tag": "Alarm Tag",
    Language: "Language",
    English: "English",
    Vietnamese: "Vietnamese",
    "Hi,": "Hi,",
    "Loading...": "Loading...",
    "New Type": "New Type",
    "New Alert Tag": "New Alarm Tag",
    "Create a new alert type, then open it to configure values and states.":
      "Create a new alarm type, then open it to configure values and states.",
    "Please input data for new alert tag": "Please input data for new alarm tag",
    "Please input data for new tag": "Please input data for new tag",
    "BASIC INFORMATION": "BASIC INFORMATION",
    Close: "Close",
    Save: "Save",
    Name: "Name",
    Description: "Description",
    "Filter Name": "Filter Name",
    "Filter Alert Type": "Filter Alarm Type",
    "Search by name": "Search by name",
    Search: "Search",
    "All Alert Types": "All Alarm Types",
    "Select alert type": "Select alarm type",
    "Source Tag": "Source Tag",
    Tag: "Tag",
    "Tag Group": "Tag Group",
    "All Tag Groups": "All Tag Groups",
    "Select source tag": "Select source tag",
    "Select tag": "Select tag",
    "Save Alert Tag": "Save Alarm Tag",
    Versions: "Versions",
    Version: "Version",
    "Created At": "Created At",
    "Tag Versions": "Tag Versions",
    Current: "Current",
    Unused: "Unused",
    "In use": "In use",
    "Delete version": "Delete version",
    "This version is still in use": "This version is still in use",
    "Are you sure you want to delete this version?": "Are you sure you want to delete this version?",
    "Alert type version deleted": "Alarm type version deleted",
    "Unable to delete alert type version": "Unable to delete alarm type version",
    "Alert tag version deleted": "Alarm tag version deleted",
    "Unable to delete alert tag version": "Unable to delete alarm tag version",
    "Old versions can be deleted only when they are no longer referenced by alert records or alert tag versions.":
      "Old versions can be deleted only when they are no longer referenced by alarm records or alarm tag versions.",
    "Old versions can be deleted only when they are no longer referenced by alert records.":
      "Old versions can be deleted only when they are no longer referenced by alarm records.",
    "Alert Type Version": "Alarm Type Version",
    "Loading alert tag...": "Loading alarm tag...",
    "Loading alert type...": "Loading alarm type...",
    "Loading alert settings...": "Loading alarm settings...",
    "Current State": "Current State",
    Inactive: "Inactive",
    Normal: "Normal",
    "matched states": "matched states",
    states: "states",
    Action: "Action",
    Delete: "Delete",
    "Are you sure you want to delete alert type with Name:":
      "Are you sure you want to delete alarm type with Name:",
    "Are you sure you want to delete alert tag with Name:":
      "Are you sure you want to delete alarm tag with Name:",
    Edit: "Edit",
    "Compare Values": "Compare Values",
    "Source Tags": "Source Tags",
    States: "States",
    "Click one alert type to open its own page for compare values, states, and simulation.":
      "Click one alarm type to open its own page for compare values, states, and simulation.",
    "Tạo alert tag cơ bản trước, sau đó bấm vào từng dòng để cấu hình tag group, tag nguồn, và các thông số.":
      "Create the basic alarm tag first, then open a row to configure tag group, source tag, and alarm parameters.",
    "1. Thông tin cơ bản": "1. Basic information",
    "2. Alert parameters": "2. Alarm parameters",
    "2. Source Tag": "2. Source Tag",
    "3. Thông số cảnh báo": "3. Alarm parameters",
    "Chọn tag group, source tag, và các thông số so sánh cho cảnh báo này.":
      "Select tag group, source tag, and comparison parameters for this alarm.",
    "Alert output tag đã được tạo tự động trong nhóm `Alerts`. Ở đây bạn chọn tag nguồn để so sánh.":
      "The alarm output tag is created automatically in the `Alarms` group. Select the source tag here for comparison.",
    "Các giá trị bên dưới sẽ được dùng trong condition của alert type đã chọn.":
      "The values below will be used in the condition of the selected alarm type.",
    "Alert type này hiện chưa có compare values.":
      "This alarm type does not have compare values yet.",
    "Enter alert tag name": "Enter alarm tag name",
    "Enter alert type name": "Enter alarm type name",
    "Enter description": "Enter description",
    "1. Tạo giá trị để so sánh": "1. Create compare values",
    "2. Tạo States": "2. Create states",
    "3. Giả lập ngõ ra": "3. Simulate output",
    Key: "Key",
    Order: "Order",
    Message: "Message",
    Color: "Color",
    Condition: "Condition",
    "No description": "No description",
    "Add Value": "Add Value",
    "Add Tag": "Add Tag",
    "Add Compare": "Add Compare",
    "Update Compare": "Update Compare",
    "Save Values": "Save Values",
    "Save Changes": "Save Changes",
    "Update State": "Update State",
    "Create State": "Create State",
    "Cancel Edit": "Cancel Edit",
    "Please create or cancel the current state before saving changes.":
      "Please create or cancel the current state before saving changes.",
    "Please add or cancel the current compare before saving changes.":
      "Please add or cancel the current compare before saving changes.",
    "Unsaved changes": "Unsaved changes",
    "You have unsaved changes. Continue without saving?": "You have unsaved changes. Continue without saving?",
    Stay: "Stay",
    Continue: "Continue",
    "Current Output": "Current Output",
    Matched: "Matched",
    "No active state.": "No active state.",
    "Allowed params:": "Allowed params:",
    "Operators:": "Operators:",
    "Condition error:": "Condition error:",
    "Condition references a key that does not exist:": "Condition references a key that does not exist:",
    "Each compare value is used in state conditions and in the Alert Tag form.":
      "Each compare value is used in state conditions and in the Alarm Tag form.",
    "Value inputs are entered manually in Alert Tag. Tag inputs let the user choose a real tag and expose its value by key in conditions.":
      "Value inputs are entered manually in Alarm Tag. Tag inputs let the user choose a real tag and expose its value by key in conditions.",
    "Keys can only use letters, numbers, hyphens, and underscores. Example: `high`, `critical_1`, `limit-max`.":
      "Keys can only use letters, numbers, hyphens, and underscores. Example: `high`, `critical_1`, `limit-max`.",
    "Key `value` is reserved for source tag data and cannot be used as a compare value.":
      "Key `value` is reserved for source tag data and cannot be used as a compare value.",
    "Conditions can use the keys created above. The first matching state becomes the active output.":
      "Conditions can use the keys created above. The first matching state becomes the active output.",
    "Conditions can use the keys created above. Any matching state will be shown in the simulation output.":
      "Conditions can use the keys created above. Any matching state will be shown in the simulation output.",
    "Example: High Value": "Example: High Value",
    "Example: Temperature Tag": "Example: Temperature Tag",
    "Example: high": "Example: high",
    "Example: temperature": "Example: temperature",
    "Example: Temperature is above threshold": "Example: Temperature is above threshold",
    "Example: `temperature > high && pressure < critical`": "Example: `temperature > high && pressure < critical`",
    "Example: temperature > high && pressure < critical": "Example: temperature > high && pressure < critical",
    "Enter values for the inputs below to see which state becomes active.":
      "Enter values for the inputs below to see which state becomes active.",
    "Configure numeric values and source tags for each key used by this alert type.":
      "Configure numeric values and source tags for each key used by this alarm type.",
    "Alert type must include at least one tag input.": "Alarm type must include at least one tag input.",
    "Please enter a key for at least one tag input.": "Please enter a key for at least one tag input.",
    "Please select all required tags.": "Please select all required tags.",
    "Needs update": "Needs update",
    "Alert type updated. Related alert tags were disabled and need review before alerts work again.":
      "Alarm type updated. Related alarm tags were disabled and need review before alarms work again.",
    "This alert tag is disabled and must be reviewed before alerts work again.":
      "This alarm tag is disabled and must be reviewed before alarms work again.",
    "Please review the parameters below and save again to reactivate this alert tag.":
      "Please review the parameters below and save again to reactivate this alarm tag.",
    create: "create",
    update: "update",
    detail: "detail",
    "display profiles": "display profiles",
    "Display Profiles": "Display Profiles",
    Create: "Create",
    Update: "Update",
    Cancel: "Cancel",
    All: "All",
    Yes: "Yes",
    No: "No",
    Tags: "Tags",
    Connections: "Connections",
    Connection: "Connection",
    Port: "Port",
    Type: "Type",
    Status: "Status",
    "Status At": "Status At",
    "Data Key": "Data Key",
    "Data Key Enabled": "Data Key Enabled",
    Enabled: "Enabled",
    Disabled: "Disabled",
    "BG Image": "BG Image",
    "Protocol (Method)": "Protocol (Method)",
    "Protocol (Methods)": "Protocol (Methods)",
    "Select Port": "Select Port",
    "Select Type": "Select Type",
    "Select Column": "Select Column",
    "Select Connection": "Select Connection",
    "Select Tag": "Select Tag",
    "Select Tag Group": "Select Tag Group",
    "Select tag group": "Select tag group",
    "Select tags": "Select tags",
    "Select tag group first": "Select tag group first",
    "Type here to search...": "Type here to search...",
    "Columns Filter": "Columns Filter",
    Value: "Value",
    Time: "Time",
    "Date Time": "Date Time",
    "Connections Management": "Connections Management",
    "Tag Groups Management": "Tag Groups Management",
    "Modbus TCP, RTU connections": "Modbus TCP, RTU connections",
    "Groups,Tags": "Groups,Tags",
    "NEW CONNECTION": "NEW CONNECTION",
    "Create Connection": "Create Connection",
    "Please provide data for new connection": "Please provide data for new connection",
    "NEW TAG GROUP": "NEW TAG GROUP",
    "Please input data for new tag group": "Please input data for new tag group",
    "Enter name": "Enter name",
    "Enter description": "Enter description",
    "Enter host": "Enter host",
    "Enter data key": "Enter data key",
    "Select Connection Type": "Select Connection Type",
    "Slave Id": "Slave Id",
    "TCP Host": "TCP Host",
    "TCP Port": "TCP Port",
    "Poll Time": "Poll Time",
    "Connect And Read Timeout (s)": "Connect And Read Timeout (s)",
    "Block Reading Max Size": "Block Reading Max Size",
    "DELETE CONNECTION": "DELETE CONNECTION",
    "DELETE TAG": "DELETE TAG",
    "Are you sure you want to delete connection with Name:":
      "Are you sure you want to delete connection with Name:",
    "Are you sure you want to delete tag group with Name:":
      "Are you sure you want to delete tag group with Name:",
    online: "online",
    offline: "offline",
    unknown: "unknown",
    Monitorings: "Monitorings",
    MONITORINGS: "MONITORINGS",
    "Data Key": "Data Key",
    "BG Image": "BG Image",
    History: "History",
    HISTORY: "HISTORY",
    Records: "Records",
    RECORDS: "RECORDS",
    "USAGE RECORDS": "USAGE RECORDS",
    "GRID DATA": "GRID DATA",
    "Data Buckets": "Data Buckets",
    "No bucket": "No bucket",
    "Chart View": "Chart View",
    "Grid View": "Grid View",
    "Delete Searched Range": "Delete Searched Range",
    "Delete searched history records?": "Delete searched history records?",
    "This action permanently deletes history records for the selected tags in the selected time range.":
      "This action permanently deletes history records for the selected tags in the selected time range.",
    "Loaded bucket records:": "Loaded bucket records:",
    "Record counts will refresh after deletion. Empty storage segments are removed so disk usage can shrink.":
      "Record counts will refresh after deletion. Empty storage segments are removed so disk usage can shrink.",
    "Type DELETE to confirm.": "Type DELETE to confirm.",
    "Delete Records": "Delete Records",
    "Selected range:": "Selected range:",
    "loaded bucket records": "loaded bucket records",
    "Max selection: 16 Tags": "Max selection: 16 Tags",
    "Clear All": "Clear All",
    "Clear Before": "Clear Before",
    "clearing...": "clearing...",
    "EST: 10m": "EST: 10m",
    "CLEAR RECORDS": "CLEAR RECORDS",
    "Are you sure you want to clear all records of:":
      "Are you sure you want to clear all records of:",
    "Are you sure you want to clear records before time of:":
      "Are you sure you want to clear records before time of:",
    "Total Rows:": "Total Rows:",
    "There are no rows please select tag and fetch data first":
      "There are no rows please select tag and fetch data first",
    "Records Total": "Records Total",
    "Switch to English": "Switch to English",
    "Switch to Vietnamese": "Switch to Vietnamese",
  },
  vi: {
    Dashboard: "Bảng điều khiển",
    Dashboards: "Bảng điều khiển",
    Monitorings: "Màn hình giám sát",
    Reports: "Báo cáo",
    History: "Lịch sử",
    Records: "Bản ghi",
    "Alarm Manager": "Quản lý Alarm",
    "Alert Manager": "Quản lý Alarm",
    Manual: "Hướng dẫn",
    Settings: "Cài đặt",
    Connections: "Kết nối",
    "Tag Groups": "Nhóm tag",
    Accounts: "Tài khoản",
    System: "Hệ thống",
    Alarms: "Alarm",
    Alerts: "Alarm",
    alarms: "alarm",
    alerts: "alarm",
    dashboard: "bảng điều khiển",
    history: "lịch sử",
    records: "bản ghi",
    manual: "hướng dẫn",
    connections: "kết nối",
    "tag groups": "nhóm tag",
    accounts: "tài khoản",
    system: "hệ thống",
    "alarm reports": "báo cáo alarm",
    "alert reports": "báo cáo alarm",
    "Alert Reports": "Báo cáo Alarm",
    Alert: "Alarm",
    "Alert:": "Alarm:",
    State: "Trạng thái",
    "State:": "Trạng thái:",
    Started: "Bắt đầu",
    Ended: "Kết thúc",
    Viewed: "Đã xem",
    Duration: "Thời lượng",
    Total: "Tổng",
    Active: "Đang hoạt động",
    Summary: "Tổng quan",
    "Active Alerts": "Alarm đang hoạt động",
    "All Active Alerts": "Tất cả alarm đang hoạt động",
    "Alert History": "Lịch sử alarm",
    "Alert Summary": "Tổng quan alarm",
    "Filter by alert": "Lọc theo alarm",
    "Click one alert row to filter its history": "Bấm vào một dòng alarm để lọc lịch sử của nó",
    "Alert Detail": "Chi tiết alarm",
    "Start value:": "Giá trị bắt đầu:",
    "End value:": "Giá trị kết thúc:",
    "Start data:": "Dữ liệu lúc bắt đầu:",
    "End data:": "Dữ liệu lúc kết thúc:",
    "Historical Alert Type": "Phiên bản Alarm Type lúc đó",
    "Historical Alert Tag": "Phiên bản Alarm Tag lúc đó",
    "Historical Configuration": "Cấu hình lịch sử",
    "Source Tags": "Các tag nguồn",
    "Marked as viewed": "Đánh dấu đã xem",
    Note: "Ghi chú",
    "Unable to load alert detail": "Không thể tải chi tiết alarm",
    "Alert record updated": "Đã cập nhật bản ghi alarm",
    "Alert records cleared": "Đã xóa bản ghi alarm",
    "Unable to update alert record": "Không thể cập nhật bản ghi alarm",
    "Unable to clear alert records": "Không thể xóa bản ghi alarm",
    "load failed": "tải thất bại",
    "update failed": "cập nhật thất bại",
    "update succeeded": "cập nhật thành công",
    "Alert Types": "Loại Alarm",
    "Alert Tags": "Tag Alarm",
    "Alert Type": "Loại Alarm",
    "Alert Tag": "Tag Alarm",
    Language: "Ngôn ngữ",
    English: "English",
    Vietnamese: "Tiếng Việt",
    "Hi,": "Xin chào,",
    "Loading...": "Đang tải...",
    "New Type": "Tạo loại mới",
    "New Alert Tag": "Tạo tag alarm",
    "Create a new alert type, then open it to configure values and states.":
      "Tạo loại alarm mới, sau đó mở ra để cấu hình giá trị so sánh và các trạng thái.",
    "Please input data for new alert tag": "Vui lòng nhập thông tin cho tag alarm mới",
    "Please input data for new tag": "Vui lòng nhập thông tin cho tag mới",
    "BASIC INFORMATION": "THÔNG TIN CƠ BẢN",
    Close: "Đóng",
    Save: "Lưu",
    Name: "Tên",
    Description: "Mô tả",
    "Filter Name": "Lọc theo tên",
    "Filter Alert Type": "Lọc theo loại alarm",
    "Search by name": "Tìm theo tên",
    Search: "Tìm kiếm",
    "All Alert Types": "Tất cả loại alarm",
    "Select alert type": "Chọn loại alarm",
    "Source Tag": "Tag nguồn",
    Tag: "Tag",
    "Tag Group": "Nhóm tag",
    "All Tag Groups": "Tất cả nhóm tag",
    "Select source tag": "Chọn tag nguồn",
    "Select tag": "Chọn tag",
    "Save Alert Tag": "Lưu tag alarm",
    Versions: "Phiên bản",
    Version: "Phiên bản",
    "Created At": "Thời gian tạo",
    "Tag Versions": "Phiên bản tag",
    Current: "Hiện tại",
    Unused: "Chưa dùng",
    "In use": "Đang được dùng",
    "Delete version": "Xóa phiên bản",
    "This version is still in use": "Phiên bản này vẫn đang được sử dụng",
    "Are you sure you want to delete this version?": "Bạn có chắc muốn xóa phiên bản này?",
    "Alert type version deleted": "Đã xóa phiên bản alarm type",
    "Unable to delete alert type version": "Không thể xóa phiên bản alarm type",
    "Alert tag version deleted": "Đã xóa phiên bản alarm tag",
    "Unable to delete alert tag version": "Không thể xóa phiên bản alarm tag",
    "Old versions can be deleted only when they are no longer referenced by alert records or alert tag versions.":
      "Chỉ có thể xóa các phiên bản cũ khi chúng không còn bị bản ghi alarm hoặc phiên bản alarm tag tham chiếu.",
    "Old versions can be deleted only when they are no longer referenced by alert records.":
      "Chỉ có thể xóa các phiên bản cũ khi chúng không còn bị bản ghi alarm tham chiếu.",
    "Alert Type Version": "Phiên bản Alarm Type",
    "Loading alert tag...": "Đang tải tag alarm...",
    "Loading alert type...": "Đang tải loại alarm...",
    "Loading alert settings...": "Đang tải cấu hình alarm...",
    "Current State": "Trạng thái hiện tại",
    Inactive: "Không kích hoạt",
    Normal: "Bình Thường",
    "matched states": "trạng thái đúng",
    states: "trạng thái",
    Action: "Thao tác",
    Delete: "Xóa",
    "Are you sure you want to delete alert type with Name:":
      "Bạn có chắc muốn xóa loại alarm có tên:",
    "Are you sure you want to delete alert tag with Name:":
      "Bạn có chắc muốn xóa tag alarm có tên:",
    Edit: "Sửa",
    "Compare Values": "Giá trị so sánh",
    States: "Trạng thái",
    "Click one alert type to open its own page for compare values, states, and simulation.":
      "Bấm vào một loại alarm để mở trang riêng cấu hình giá trị so sánh, trạng thái và mô phỏng.",
    "Tạo alert tag cơ bản trước, sau đó bấm vào từng dòng để cấu hình tag group, tag nguồn, và các thông số.":
      "Tạo tag alarm cơ bản trước, sau đó bấm vào từng dòng để cấu hình nhóm tag, tag nguồn và các thông số.",
    "1. Thông tin cơ bản": "1. Thông tin cơ bản",
    "2. Alert parameters": "2. Thông số alarm",
    "2. Source Tag": "2. Tag nguồn",
    "3. Thông số cảnh báo": "3. Thông số alarm",
    "Chọn tag group, source tag, và các thông số so sánh cho cảnh báo này.":
      "Chọn nhóm tag, tag nguồn và các thông số so sánh cho alarm này.",
    "Alert output tag đã được tạo tự động trong nhóm `Alerts`. Ở đây bạn chọn tag nguồn để so sánh.":
      "Tag đầu ra của alarm đã được tạo tự động trong nhóm `Alarms`. Tại đây bạn chọn tag nguồn để so sánh.",
    "Các giá trị bên dưới sẽ được dùng trong condition của alert type đã chọn.":
      "Các giá trị bên dưới sẽ được dùng trong điều kiện của loại alarm đã chọn.",
    "Alert type này hiện chưa có compare values.":
      "Loại alarm này hiện chưa có giá trị so sánh.",
    "Enter alert tag name": "Nhập tên tag alarm",
    "Enter alert type name": "Nhập tên loại alarm",
    "Enter description": "Nhập mô tả",
    "1. Tạo giá trị để so sánh": "1. Tạo giá trị để so sánh",
    "2. Tạo States": "2. Tạo trạng thái",
    "3. Giả lập ngõ ra": "3. Giả lập ngõ ra",
    Key: "Key",
    Order: "Thứ tự",
    Message: "Thông báo",
    Color: "Màu sắc",
    Condition: "Điều kiện",
    "No description": "Chưa có mô tả",
    "Add Value": "Thêm giá trị",
    "Add Tag": "Thêm tag",
    "Add Compare": "Thêm so sánh",
    "Update Compare": "Cập nhật so sánh",
    "Save Values": "Lưu giá trị",
    "Save Changes": "Lưu thay đổi",
    "Update State": "Cập nhật state",
    "Create State": "Tạo state",
    "Cancel Edit": "Hủy sửa",
    "Please create or cancel the current state before saving changes.":
      "Vui lòng tạo hoặc hủy state đang chỉnh sửa trước khi lưu thay đổi.",
    "Please add or cancel the current compare before saving changes.":
      "Vui lòng thêm hoặc hủy compare hiện tại trước khi lưu thay đổi.",
    "Unsaved changes": "Thay đổi chưa lưu",
    "You have unsaved changes. Continue without saving?": "Bạn có thay đổi chưa lưu. Vẫn tiếp tục thoát?",
    Stay: "Ở lại",
    Continue: "Tiếp tục",
    "Current Output": "Ngõ ra hiện tại",
    Matched: "Khớp",
    "No active state.": "Không có state nào active.",
    "Allowed params:": "Biến được phép:",
    "Operators:": "Phép toán:",
    "Condition error:": "Lỗi điều kiện:",
    "Condition references a key that does not exist:": "Điều kiện đang dùng key không tồn tại:",
    "Each compare value is used in state conditions and in the Alert Tag form.":
      "Mỗi giá trị so sánh sẽ được dùng trong condition của state và trong form Alarm Tag.",
    "Value inputs are entered manually in Alert Tag. Tag inputs let the user choose a real tag and expose its value by key in conditions.":
      "Các input kiểu giá trị sẽ nhập tay trong Alarm Tag. Các input kiểu tag sẽ cho người dùng chọn tag thực và dùng giá trị của tag đó theo key trong condition.",
    "Keys can only use letters, numbers, hyphens, and underscores. Example: `high`, `critical_1`, `limit-max`.":
      "Key chỉ được dùng chữ cái, số, dấu gạch ngang và gạch dưới. Ví dụ: `high`, `critical_1`, `limit-max`.",
    "Key `value` is reserved for source tag data and cannot be used as a compare value.":
      "Key `value` là biến dành riêng cho dữ liệu từ tag nguồn nên không được dùng làm giá trị so sánh.",
    "Conditions can use the keys created above. The first matching state becomes the active output.":
      "Condition được phép dùng các key đã tạo ở phần trên. State đầu tiên match sẽ là ngõ ra active.",
    "Conditions can use the keys created above. Any matching state will be shown in the simulation output.":
      "Condition được phép dùng các key đã tạo ở phần trên. Mọi state khớp sẽ được hiển thị trong phần mô phỏng.",
    "Example: High Value": "Ví dụ: Giá trị cao",
    "Example: Temperature Tag": "Ví dụ: Tag nhiệt độ",
    "Example: high": "Ví dụ: high",
    "Example: temperature": "Ví dụ: temperature",
    "Example: Temperature is above threshold": "Ví dụ: Nhiệt độ vượt ngưỡng",
    "Example: `temperature > high && pressure < critical`": "Ví dụ: `temperature > high && pressure < critical`",
    "Example: temperature > high && pressure < critical": "Ví dụ: temperature > high && pressure < critical",
    "Enter values for the inputs below to see which state becomes active.":
      "Nhập các giá trị bên dưới để kiểm tra state nào sẽ active.",
    "Configure numeric values and source tags for each key used by this alert type.":
      "Cấu hình giá trị số và tag nguồn cho từng key mà loại alarm này sử dụng.",
    "Alert type must include at least one tag input.":
      "Loại alarm phải có ít nhất một trường kiểu tag.",
    "Please enter a key for at least one tag input.":
      "Vui lòng nhập key cho ít nhất một trường kiểu tag.",
    "Please select all required tags.": "Vui lòng chọn đầy đủ các tag bắt buộc.",
    "Needs update": "Cần cập nhật",
    "Alert type updated. Related alert tags were disabled and need review before alerts work again.":
      "Alarm type đã được cập nhật. Các alarm tag liên quan đã bị tắt và cần được kiểm tra, lưu lại trước khi alarm hoạt động lại.",
    "This alert tag is disabled and must be reviewed before alerts work again.":
      "Alarm tag này đang bị vô hiệu và cần được kiểm tra lại trước khi alarm hoạt động trở lại.",
    "Please review the parameters below and save again to reactivate this alert tag.":
      "Vui lòng kiểm tra lại các thông số bên dưới rồi lưu lại để kích hoạt lại alarm tag này.",
    create: "tạo mới",
    update: "cập nhật",
    detail: "chi tiết",
    "display profiles": "cấu hình hiển thị",
    "Display Profiles": "Cấu hình hiển thị",
    Create: "Tạo mới",
    Update: "Cập nhật",
    Cancel: "Hủy",
    All: "Tất cả",
    Yes: "Đồng ý",
    No: "Không",
    Tags: "Tags",
    Connections: "Kết nối",
    Connection: "Kết nối",
    Port: "Cổng",
    Type: "Loại",
    Status: "Trạng thái",
    "Status At": "Thời điểm trạng thái",
    "Data Key": "Khóa dữ liệu",
    "Data Key Enabled": "Bật khóa dữ liệu",
    Enabled: "Bật",
    Disabled: "Tắt",
    "BG Image": "Ảnh nền",
    "Protocol (Method)": "Giao thức (Phương thức)",
    "Protocol (Methods)": "Giao thức (Phương thức)",
    "Select Port": "Chọn cổng",
    "Select Type": "Chọn loại",
    "Select Column": "Chọn cột",
    "Select Connection": "Chọn kết nối",
    "Select Tag": "Chọn tag",
    "Select Tag Group": "Chọn nhóm tag",
    "Select tag group": "Chọn nhóm tag",
    "Select tags": "Chọn tags",
    "Select tag group first": "Hãy chọn nhóm tag trước",
    "Type here to search...": "Nhập để tìm kiếm...",
    "Columns Filter": "Bộ lọc cột",
    Value: "Giá trị",
    Time: "Thời gian",
    "Date Time": "Ngày giờ",
    "Connections Management": "Quản lý kết nối",
    "Tag Groups Management": "Quản lý nhóm tag",
    "Modbus TCP, RTU connections": "Các kết nối Modbus TCP, RTU",
    "Groups,Tags": "Nhóm,Tags",
    "NEW CONNECTION": "TẠO KẾT NỐI MỚI",
    "Create Connection": "Tạo kết nối",
    "Please provide data for new connection": "Vui lòng nhập thông tin cho kết nối mới",
    "NEW TAG GROUP": "TẠO NHÓM TAG MỚI",
    "Please input data for new tag group": "Vui lòng nhập thông tin cho nhóm tag mới",
    "Enter name": "Nhập tên",
    "Enter description": "Nhập mô tả",
    "Enter host": "Nhập host",
    "Enter data key": "Nhập khóa dữ liệu",
    "Select Connection Type": "Chọn loại kết nối",
    "Slave Id": "Slave Id",
    "TCP Host": "TCP Host",
    "TCP Port": "TCP Port",
    "Poll Time": "Chu kỳ đọc",
    "Connect And Read Timeout (s)": "Thời gian chờ kết nối và đọc (giây)",
    "Block Reading Max Size": "Kích thước đọc khối tối đa",
    "DELETE CONNECTION": "XÓA KẾT NỐI",
    "DELETE TAG": "XÓA NHÓM TAG",
    "Are you sure you want to delete connection with Name:":
      "Bạn có chắc muốn xóa kết nối có tên:",
    "Are you sure you want to delete tag group with Name:":
      "Bạn có chắc muốn xóa nhóm tag có tên:",
    online: "trực tuyến",
    offline: "ngoại tuyến",
    unknown: "không rõ",
    MONITORINGS: "MÀN HÌNH GIÁM SÁT",
    HISTORY: "LỊCH SỬ",
    RECORDS: "BẢN GHI",
    "USAGE RECORDS": "THỐNG KÊ BẢN GHI",
    "GRID DATA": "DỮ LIỆU BẢNG",
    "Data Buckets": "Các bucket dữ liệu",
    "No bucket": "Không có bucket",
    "Chart View": "Biểu đồ",
    "Grid View": "Dạng bảng",
    "Delete Searched Range": "Xóa vùng đã tìm",
    "Delete searched history records?": "Xóa dữ liệu lịch sử đã tìm?",
    "This action permanently deletes history records for the selected tags in the selected time range.":
      "Thao tác này sẽ xóa vĩnh viễn dữ liệu lịch sử của các tag đã chọn trong khoảng thời gian đã chọn.",
    "Loaded bucket records:": "Số bản ghi bucket đã tải:",
    "Record counts will refresh after deletion. Empty storage segments are removed so disk usage can shrink.":
      "Số lượng bản ghi sẽ được làm mới sau khi xóa. Các vùng lưu trữ trống sẽ được dọn để dung lượng đĩa có thể giảm.",
    "Type DELETE to confirm.": "Nhập DELETE để xác nhận.",
    "Delete Records": "Xóa bản ghi",
    "Selected range:": "Khoảng đã chọn:",
    "loaded bucket records": "bản ghi bucket đã tải",
    "Max selection: 16 Tags": "Chọn tối đa: 16 Tags",
    "Clear All": "Xóa toàn bộ",
    "Clear Before": "Xóa trước thời điểm",
    "clearing...": "đang xóa...",
    "EST: 10m": "Ước tính: 10p",
    "CLEAR RECORDS": "XÓA BẢN GHI",
    "Are you sure you want to clear all records of:":
      "Bạn có chắc muốn xóa toàn bộ bản ghi của:",
    "Are you sure you want to clear records before time of:":
      "Bạn có chắc muốn xóa các bản ghi trước thời điểm của:",
    "Total Rows:": "Tổng số dòng:",
    "There are no rows please select tag and fetch data first":
      "Hiện chưa có dòng dữ liệu, hãy chọn tag và tải dữ liệu trước",
    "Records Total": "Tổng số bản ghi",
    "Switch to English": "Chuyển sang English",
    "Switch to Vietnamese": "Chuyển sang Tiếng Việt",
  },
};

export const translateText = (text, locale = "en") => {
  if (!text) {
    return text;
  }
  return translations[locale]?.[text] || text;
};
